
















import CommonButton from '@/components/button/CommonButton.vue';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';

import Component from 'vue-class-component';
import {Mixins, Prop} from 'vue-property-decorator';
import {CommonConfirmDialogRequest} from '@/model/CommonModel';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import '@/plugins/Modal';

@Component({
    components: {
        CommonButton,
        CommonPromptDialog,
    },
    mixins: [DialogEventsMixin],
})
export default class CommonConfirmDialog extends Mixins<DialogEventsMixin>(DialogEventsMixin) {
    private title: string = '';
    private content: string = '';
    private htmlContent: string = '';
    private loading: boolean = false;
    private dialogVisible: boolean = false;
    private cancelVisible: boolean = true;

    private onConfirm: ((context: CommonConfirmDialog) => void) | undefined;
    private onCancel: (() => void) | undefined;

    get getTitle() {
        return this.title;
    }

    get getContent() {
        return this.content;
    }

    get getHtmlContent() {
        return this.htmlContent;
    }
    
    get isVisible() {
        return this.dialogVisible;
    }
    
    get isLoading() {
        return this.loading;
    }

    get isCancelVisible() {
        return this.cancelVisible;
    }
    
    public mounted() {
        this.$modal
            .getEventBus()
            .$on('showCommonConfirmDialog', (params: CommonConfirmDialogRequest) => {
                this.show(params);
            });

        this.$modal.getEventBus().$on('hideCommonConfirmDialog', () => this.cancel());
    }
    
    public beforeApiCall() {
        this.loading = true;
    }
    
    public afterApiCall() {
        this.loading = false;
    }
    
    public confirm() {
        if (this.loading) {
            return;
        }

        if (this.onConfirm instanceof Function) {
            this.onConfirm(this);
        } else {
            this.hide();
        }
    }
    
    public cancel() {
        if (this.onCancel instanceof Function) {
            this.onCancel();
        }
        this.hide();
    }

    public show(params: CommonConfirmDialogRequest) {
        this.dialogVisible = true;
        this.title = params.title;
        this.content = params.content;
        this.htmlContent = params.htmlContent ?? '';
        this.cancelVisible = params.cancelVisible ?? true;
        const {onConfirm, onCancel} = params;
        this.onConfirm = onConfirm;
        this.onCancel = onCancel;
    }

    public hide() {
        this.dialogVisible = false;
    }

    public destroyed() {
        this.$modal.getEventBus().$off('showCommonConfirmDialog');
        this.$modal.getEventBus().$off('hideCommonConfirmDialog');
    }
}
